import React from "react";
import Announcement from "./Announcement";
import Footer from "./Footer";
import Slider from "./Slider";

const Homes = () => {
  return (
    <div>
      <Announcement />
      <Slider />
      {/* <Footer/> */}
    </div>
  );
};

export default Homes;
